import React, { useState, useEffect } from "react";

import cube from "services/cube";
import { Form, Loading } from "components";

export function Discounts({ onChange, value }) {
  const [discounts, setDiscounts] = useState([]);

  useEffect(() => {
    cube
      .get("/list/discounts")
      .then((response) =>
        setDiscounts(response.data.map((discount) => Number(discount)))
      )
      .catch((error) => console.error(error));
  }, []);

  if (!discounts.length) {
    return <Loading />;
  }

  return (
    <Form.Select
      placeholder="Todos"
      value={value}
      onChange={onChange}
      options={discounts.map((discount) => ({
        value: discount,
        label: `${Number(discount)}%`,
      }))}
    />
  );
}
